export default {"src":"/_next/static/media/shields.e05169ca.svg","height":99,"width":281};